import { RichText } from '@brunommsilva/react-foundations';

import AssistantAvatar from '../assistant-avatar';
import AbstractMessageBubble from './abstract-message-bubble';

interface AssistantMessageBubbleProps {
  text: string;
  isError?: boolean;
}

/** What the assistant said: markdown, with lists and tables, and :shortcodes: turned into emoji, or the error that replaced it. */
export default function AssistantMessageBubble({
  text,
  isError,
}: AssistantMessageBubbleProps) {
  return (
    <AbstractMessageBubble
      side="start"
      avatar={<AssistantAvatar />}
      bubbleSx={{
        bgcolor: 'action.hover',
        color: isError ? 'error.main' : 'text.primary',
        '& p': { m: 0 },
        '& p + p, & ul + p, & p + ul': { mt: 1 },
        '& ul, & ol': { m: 0, pl: 2.5 },
      }}
    >
      <RichText text={text} markdown emoji />
    </AbstractMessageBubble>
  );
}
